<template>
  <div class="layout">
    <TheHeader />

    <div class="layout__content">
      <TheSubmenu
        :root="submenuRoot"
        :urls="submenuUrls"
      />

      <Nuxt />
    </div>

    <TheFooter />
  </div>
</template>

<script>
import { TheHeader } from '~/components/the-header'
import { TheFooter } from '~/components/the-footer'
import { getUrls, getRootUrl, getPageType } from '~/assets/js/services/submenu'
import { TheSubmenu } from '~/components/the-submenu'

export default {
  name: 'DefaultLayout',
  components: {
    TheFooter,
    TheHeader,
    TheSubmenu,
  },

  head () {
    return {
      link: [
        {
          rel: 'canonical',
          href: this.canonicalUrl,
        },
      ],
    }
  },

  computed: {
    submenuRoot () {
      return getRootUrl([getPageType(this.$route.name)])
    },
    submenuUrls () {
      return getUrls([getPageType(this.$route.name)])
    },
    canonicalUrl () {
      const baseUrl = 'https://querobolsa.com.br'

      if (this.$route.path !== '/' && this.$route.path.endsWith('/')) {
        return baseUrl + this.$route.path.replace(/\/$/, '')
      }

      return baseUrl + this.$route.path
    },
  },
}
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.layout__content {
  flex: 1;
}
</style>
